import { render, staticRenderFns } from "./KTabsList.vue?vue&type=template&id=8c0d7690&scoped=true"
import script from "./KTabsList.vue?vue&type=script&lang=js"
export * from "./KTabsList.vue?vue&type=script&lang=js"
import style0 from "./KTabsList.vue?vue&type=style&index=0&id=8c0d7690&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c0d7690",
  null
  
)

export default component.exports